import { Link } from "react-router-dom";
import SEO from "@/components/site/SEO";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  return (
    <div
      data-testid="not-found-page"
      className="min-h-[60vh] flex items-center justify-center bg-white px-6"
    >
      <SEO title="Page Not Found" description="That page doesn't exist on 901lots.com." path="/404" noIndex />
      <div className="text-center max-w-md">
        <div className="font-display font-black text-blue-700 text-7xl">404</div>
        <h1 className="mt-4 font-display font-bold text-slate-900 text-3xl">
          Page not found
        </h1>
        <p className="mt-3 text-slate-600">
          That page doesn't exist — but your parking lot quote is still
          one click away.
        </p>
        <Button
          asChild
          className="mt-6 bg-orange-600 hover:bg-orange-700 text-white"
          data-testid="notfound-home-cta"
        >
          <Link to="/">Back to home</Link>
        </Button>
      </div>
    </div>
  );
}
